<div class="layout-main">
  <div class="container-fluid">
    <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
      <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
        <ol class="breadcrumb ol-sf-1">
          <li class="breadcrumb-item">
            <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent().company.uniqid}}">Home</a>
            <a *roles="['ROLE_CLIENT']" routerLink="/client/{{getUserCurrent().company.uniqid}}">Home</a>
          </li>
          <li class="breadcrumb-item">
            <a routerLink="/dad-admin">Dad Admin</a>
          </li>
          <li aria-current="page" class="breadcrumb-item active">
            Dad Form
          </li>
        </ol>
      </nav>
    </nav>

    <p-message *ngIf="currentDad" severity="warn" [text]="getWarningText()" styleClass="mt-12 block bold-label"/>
    <br>
    <br>

    <app-eurex-report *ngIf="currentDad?.dadConfig?.id === 2 && previousMonthSubscriptionData !== null"
                      [currentDad]="currentDad" [previousMonthSubscriptionData]="previousMonthSubscriptionData"
                      [scheduleNumber]="3" [originalClientDeclarationMode]="originalClientDeclarationMode">
      <span>
        (All locations with Access to Deutsche Börse CEF ultra+ Eurex Order by Order Pricing Data must be reported. Add
        additional lines as needed for multiple locations or complete separate declarations)
      </span>
      <div>
        *Each access ID that is entitled to view the data, whether or not they actually see it, needs to be reported
        monthly.
        <br><br>
        This Declaration Form confirms that the Subscriber named above is using
        the CEF ultra+ Eurex Order by Order Pricing Data for internal purposes only
        and that the Subscriber will seek permission from Deutsche Börse prior
        to using any Deutsche Börse Data outside of the Subscriber's internal network.
      </div>
    </app-eurex-report>
    <app-eurex-report *ngIf="currentDad?.dadConfig?.id === 3 && previousMonthSubscriptionData !== null"
                      [currentDad]="currentDad" [previousMonthSubscriptionData]="previousMonthSubscriptionData"
                      [scheduleNumber]="5" [originalClientDeclarationMode]="originalClientDeclarationMode">
      <span>
        (All locations with Access to Euronext Pricing Data must be reported.)
      </span>
      <div>
        *Each access ID that is entitled to view the data, whether or not they actually see it, needs to be reported
        monthly.
        <br>
        <br>
        This Declaration Form confirms that the Subscriber named above is using the Euronext Equity and Index
        Derivatives
        Data for internal purposes only and that the Subscriber will seek permission from Euronext prior to using any
        Euronext Content outside of the Subscriber's internal network.
      </div>
    </app-eurex-report>
    <app-eurex-report *ngIf="currentDad?.dadConfig?.id === 5 && previousMonthSubscriptionData !== null"
                      [currentDad]="currentDad" [previousMonthSubscriptionData]="previousMonthSubscriptionData"
                      [scheduleNumber]="6" [originalClientDeclarationMode]="originalClientDeclarationMode">
      <span>
        (All locations with Access to LME Pricing Data must be reported.)
      </span>
      <div>
        *If the data is being used in applications on several machines and in several colos then each instance of an
        application should be reported as a separate subscriber.
        <br>
        <br>
        If LME data is being used as reference price in transactions, or for valuation or pricing activities , or
        distributed externally in any form,
        {{ currentDad.billingAccountName }} may need a Usage license.
        Please reference https://www.lme.com/en-GB/Market-Data/Market-data-licensing/Usage#tabIndex=0, and email
        datalicensing&#64;lme.com if you have any questions.
      </div>
    </app-eurex-report>
    <app-ice-report *ngIf="currentDad?.dadConfig?.id === 1 && previousMonthSubscriptionData !== null"
                    [currentDad]="currentDad" [originalClientDeclarationMode]="originalClientDeclarationMode"
                    [previousMonthSubscriptionData]="previousMonthSubscriptionData"></app-ice-report>
    <app-lse-report *ngIf="currentDad?.dadConfig?.id === 6"
                    [currentDad]="currentDad" [originalClientDeclarationMode]="originalClientDeclarationMode"
                    [previousMonthSubscriptionData]="previousMonthSubscriptionData"></app-lse-report>
    <app-turq-report *ngIf="currentDad?.dadConfig?.id === 7"
                     [currentDad]="currentDad" [originalClientDeclarationMode]="originalClientDeclarationMode"
                     [previousMonthSubscriptionData]="previousMonthSubscriptionData"></app-turq-report>
  </div>
</div>
